var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{on:{"click":_vm.handleClick}},[_vm._t("default"),_c('portal',[(!_vm.isLogin)?_c('bindMobile',_vm._b({on:{"success":_vm.loginSuccess},model:{value:(_vm.isShowLoginModel),callback:function ($$v) {_vm.isShowLoginModel=$$v},expression:"isShowLoginModel"}},'bindMobile',_vm.finalBindMobileComponentsProps,false)):_vm._e()],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }